/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./PayoutAlert.css";

/**
 * "Donations cannot reach you right now", above the dashboard (CP-304).
 *
 * Plug's checkout refuses to move money to a nonprofit whose Stripe account
 * is not in order, and this is the only place in the Plug workspace that says
 * so. CheckPlus says it on AccountOverview, but a Plug-origin nonprofit may
 * never open that page — so without this card its donations simply stop, with
 * nothing on screen accounting for it.
 *
 * Louder than ProfileNudge on purpose. An unanswered profile question costs
 * an organisation some visibility; this costs it every donation, and the two
 * should not read as the same weight of problem.
 *
 * Renders nothing when handed null, which is what an account in good standing
 * gets — and also what an unanswered fetch gets, so a healthy dashboard never
 * flashes an alarm on its way to finding out.
 */
class PayoutAlert extends Component {
  render() {
    const alert = this.props.alert;
    if (!alert) {
      return null;
    }
    return (
      <div className="Marketplace-PayoutAlert" role="status">
        <span className="Marketplace-PayoutAlert-mark" aria-hidden="true">
          !
        </span>
        <div className="Marketplace-PayoutAlert-copy">
          <div className="Marketplace-PayoutAlert-title">{alert.title}</div>
          <div className="Marketplace-PayoutAlert-body">{alert.body}</div>
        </div>
        {/* Only the deferred state carries an action: it is the one thing an
            organisation finishes itself. The rest are Stripe withholding a
            capability, where a button would promise a remedy that is not
            there. */}
        {alert.cta ? (
          <a
            className="Marketplace-PayoutAlert-cta"
            href={alert.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {alert.cta}
          </a>
        ) : null}
      </div>
    );
  }
}

PayoutAlert.propTypes = {
  /* null when the organisation can be paid, or before Stripe has answered. */
  alert: PropTypes.object,
};

export default PayoutAlert;
